module.exports = __webpack_public_path__ + "img/pencairan.0afff4e0.png";